/* @flow strict */

import * as React from 'react';
import { getWordsCount } from '/client/src/utils/string';
import TextEditor from 'client/src/components/textEditor';

type PropsType = {
  value: string,
  onChange: (string) => void,
  setValidateDataLength: () => void
};

const EventDescr = ({ value, onChange, setValidateDataLength }: PropsType): React.Element<'div'> => {
  const limit = 50000;

  return (
    <div className={'form-group SimpleInput ReactSummernote'}>
      <label htmlFor="eventUrl">Event Description (required)</label>
      <React.Suspense>
        {navigator ?
          <TextEditor
            customClass={'js-anchor-event-description'}
            value={value}
            limit={limit}
            onChange={
              (data: any): void => {
                const _isShowLimitWarning = getWordsCount(data) - 11 > limit;

                if (_isShowLimitWarning) {
                  setValidateDataLength('js-anchor-event-description');
                } else {
                  setValidateDataLength('js-anchor-event-description', 1);
                }

                onChange({
                  target: {
                    name: 'long_description',
                    value: data
                  }
                });
              }
            }
          />
          : null
        }
      </React.Suspense>
    </div>
  );
};

export default EventDescr;
